/* CRO: product-page WhatsApp float. Moves the button to <body> (so position:fixed is never
   trapped by a transformed ancestor) and keeps it above the sticky add-to-cart bar when that bar is visible. */
(function () {
  function initPdpWa() {
    var fl = document.querySelector('[data-pdp-wa-float]');
    if (!fl) return;
    if (fl.parentNode !== document.body) document.body.appendChild(fl);
    var bar = document.querySelector('sticky-add-to-cart');
    function upd() {
      var off = bar && bar.classList.contains('visible') ? bar.getBoundingClientRect().height + 8 : 0;
      fl.style.setProperty('--pdp-wa-offset', off + 'px');
    }
    upd();
    if (bar) {
      new MutationObserver(upd).observe(bar, { attributes: true, attributeFilter: ['class'] });
      window.addEventListener('resize', upd);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPdpWa);
  } else {
    initPdpWa();
  }
})();
